export default "__VITE_ASSET__CstInUQ2__"